module.exports = __webpack_public_path__ + "4a5bba911caf2e885e8998ed372fe89d.pdf";